export default __webpack_public_path__ + "static/media/Matting_Dashboard_banner_1.d2473f55.jpg";